/** @jsx jsx */
/** @jsxfrag */
import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';

import type { SurfaceModule } from '@atlassian/surface-sdk';

import { type Actions } from '../../index';

import { type AppRecommendationsSectionListProps } from './app-recommendations-list/types';
import { type AppRecommendationsProps } from './types';

export const AppRecommendations: SurfaceModule<
	AppRecommendationsProps,
	AppRecommendationsSectionListProps,
	Actions
> = ({ children }) => <>{children}</>;
